export default "__VITE_ASSET__4ea43b6d__"